
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVisibilityOffGoogle as ObiVisibilityOffGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-visibility-off-google.js';
 
 
 

 
 export const ObiVisibilityOffGoogle = createComponent({
   react: React,
   tagName: 'obi-visibility-off-google',
   elementClass: ObiVisibilityOffGoogleElement,
   events: {
     
   }
  });
 
 